import { api } from '@/lib/api';

export interface CartItem {
  id: string;
  providerAgentId: string;
  taskDescription: string | null;
  addedAt: string;
  agentName: string;
  agentSlug: string;
  agentDescription: string;
  pricingModel: string;
  priceAmount: string;
  currency: string;
  onlineStatus: string;
  agentStatus: string;
  // E1/G2 C1:下单按供方分组。
  ownerId: string;
  ownerName: string | null;
  ownerAvatarUrl: string | null;
}

// CartBadge 与 CartPage 共享 ['cart'] 缓存。react-query 对同一 queryKey 只保留
// 一份缓存数据，因此各处必须用【完全相同】的 queryKey 与返回形状，否则先解析的
// 组件写入形状不符的数据，另一组件会拿到错误形状（如把对象当数组 .map 而崩溃）。
export const cartQuery = {
  queryKey: ['cart'] as const,
  queryFn: async (): Promise<CartItem[]> => {
    const r = await api.get<{ data: CartItem[] }>('/api/cart');
    return r.data ?? [];
  },
};
